import { css } from "@emotion/react";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const navigationItemButtonStyles = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  lineHeight: "21px",
  width: "100%",
  paddingBlock: withVar(SpacingToken.Spacing2),
  border: "none",
  background: "none",
  fontSize: "14px",
  textDecoration: "none",
  boxSizing: "border-box",
  color: `${withVar(DesignToken.ContentBasicSecondary)}`,
  "&:hover": {
    color: `${withVar(DesignToken.ActionPrimaryDefault)}`,
  },
  '&[data-active="true"]': {
    color: `${withVar(DesignToken.ActionPrimaryDefault)}`,
    fontWeight: 600,
  },
  "&:focus": {
    outline: "none",
  },
  "&:focus-visible": {
    color: `${withVar(DesignToken.ActionPrimaryDefault)}`,
    outline: `1px solid ${withVar(DesignToken.ActionPrimaryDefault)}`,
  },
});

export const newBadgeStyles = css({
  color: `${withVar(DesignToken.ActionNegativeDefault)}`,
  fontWeight: 600,
  fontSize: "14px",
});

export const migrationLinkStyles = css({
  color: withVar(DesignToken.ActionPrimaryDefault),
  textDecoration: "none",
});
